module.exports = __webpack_public_path__ + "media/images/metal_silver-26610a3c.png";